import { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { get, patch } from "../../../../services/apiService";
import { toast } from "react-toastify";
import BackdropLoader from "../../../../components/common/BackdropLoader";
import EditableComponent from "../../components/sections/editable-component/EditableComponent";
import PreviewComponent from "../../components/sections/preview-component/PreviewComponent";
import Button from "../../components/common/button";
import EditableSocialSection from "../../components/sections/social-Links/editable";
import i18next from "i18next";
import useWindowSize from "../../../../hooks/useWindowSize";
import { Box } from "@mui/material";


const SectionPreviewPage = () => {
  const [editable, setEditable] = useState(false);
  const previewMode = useSelector((state) => state.previewMode);
  const userId = sessionStorage.getItem("userId");
  const [isLoading, setIsLoading] = useState(false);
  const { id: userSectionId } = useParams();
  const [sectionHtml, setSectionHtml] = useState("");
  const { width: screenWidth } = useWindowSize();
  const [content, setSectionContent] = useState({
    headings: [],
    descriptions: [],
    images: [],
    navbar: [],
  });
  const [sectionTheme, setSectionTheme] = useState({});
  const [socialMediaData, setSocialMediaData] = useState([]);

  const currentLanguage = i18next.language;

  const onLoading = (isLoading) => {
    setIsLoading(isLoading);
  };

  const isValidTranslation = (items, language) => {
    return items.every((item) => {
      const translation = item.translation.find(
        (t) => t.languageCode === language
      );

      if (!translation || !translation.languageText) return false;

      const text = translation.languageText.trim();

      try {
        // Check if it's a JSON string
        const parsed = JSON.parse(text);

        // Only proceed if it's an object
        if (typeof parsed === "object" && parsed !== null) {
          // If any value is falsy or empty string, return false
          const hasEmptyValue = parsed.some(
            (val) => typeof val.text === "string" && (val.text.trim().length === 0 || val.link.trim().length === 0)
          );
          return !hasEmptyValue;
        }
      } catch (e) {
        // Not a JSON string, treat it as normal text
      }

      // Fallback to regular text check
      return text.length > 0;
    });
  };

  const saveContent = async () => {
    console.log("content inside save content-------->", content);
    // I want to check that if currentLanguage is en then check the  length of languageText of currect language inside the translations key is greater than 0
    if (
      content.headings &&
      content.descriptions &&
      content.images &&
      content.navbar &&
      socialMediaData &&
      isValidTranslation(content.headings, currentLanguage) &&
      isValidTranslation(content.descriptions, currentLanguage) &&
      isValidTranslation(content.images, currentLanguage) &&
      isValidTranslation(content.navbar, currentLanguage) &&
      isValidTranslation(socialMediaData, currentLanguage)
    ) {
      let finalArray = [];
      console.log("api social links-------------->", socialMediaData);
      if (socialMediaData.length > 0) {
        // const socialMediaObject = socialMediaData;

        // Check if headings exist before accessing index 0
        if (content.headings && socialMediaData.length > 0) {
          finalArray.push(content.headings[0], ...socialMediaData);
        } else {
          finalArray.push(socialMediaData);
        }
      } else {
        finalArray = [
          ...(content.headings || []),
          ...(content.descriptions || []),
          ...(content.images || []),
        ];
      }
      let currentScreenNavbar = [];
      if (content.navbar.length > 0) {
        console.log("navbar--------->", content.navbar);

        // Use direct indexing instead of filter()
        currentScreenNavbar = content.navbar[screenWidth > 800 ? 0 : 1];

        // Push navbar data as an array to maintain previous behavior
        finalArray.push(currentScreenNavbar);
      }

      console.log("final array--------------->", finalArray);
      const object = {
        sectionContent: finalArray,
      };
      const response = await patch(
        `users/${userId}/section/${userSectionId}/content`,
        object,
        {},
        onLoading
      );
      if (response.status === 200) {
        fetchContentBySectionId();
        setEditable(false);
      }
    } else {
      toast.error("Please Enter all the details");
    }
  };

  const fetchContentBySectionId = useCallback(async () => {
    const response = await get(
      `users/${userId}/section/${userSectionId}`,
      {},
      onLoading
    );
    console.log("content response-------------->", response);
    if(response?.data?.content?.length>0) {

    console.log("content condition true--------------", response);

    let contentArray;
    if (!Array.isArray(response?.data?.content)) {
      contentArray = response?.data?.content ? JSON?.parse(response?.data?.content) : "";
    } else {
      contentArray = response?.data?.content;
    }
    console.log("content array------------->", contentArray);

    const socialLinks = contentArray.filter(
      (content) => content.contentType === "sociallinksfooter" // Ensure correct case
    );
    console.log("required socialLinks----------->", socialLinks);

    if (socialLinks[0]?.content?.length > 0) {
      try {
        console.log("inside socialLinks condition---------------->");
        // const updatedSocialLinks = JSON.parse(socialLinks);
        // setSocialMediaId(socialLinks[0].id);
        // const checkedSocialData = JSON.parse(socialLinks[0].content).map((social) => {
        //   return {
        //     ...social,
        //     check: true,
        //   };
        // });
        // console.log('setting social links-------------->', socialLinks)
        // setApiSocialLinks(checkedSocialData);
        // const filteredData = filterTranslation(socialLinks, currentLanguage);
        // console.log('filtered data------------>', filteredData);
        setSocialMediaData(socialLinks);
      } catch (error) {
        console.error("Error parsing social links JSON:", error.message);
      }
    }

    const textSections = contentArray.filter(
      (content) => content.contentType === "p" || content.contentType === "text"
    );
    const imageSections = contentArray.filter(
      (content) => content.contentType === "img"
    );

    const navbarSections = contentArray.filter(
      (content) => content.contentType === "nav"
    );

    const headingSections = contentArray.filter((content) =>
      content.contentType.includes("h")
    );
    const spanSections = contentArray.filter(
      (content) => content.contentType === "span"
    );

    if (Array.isArray(headingSections) && headingSections.length > 0) {
      const headings = headingSections.map((section) => {
        return {
          id: section.id,
          content: section.content,
          contentType: section.contentType,
          translation: section?.translation,
        };
      });
      if (spanSections.length > 0) {
        const spanTexts = spanSections.map((section) => {
          return {
            id: section.id,
            content: section.content,
            contentType: section.contentType,
            translation: section?.translation,
          };
        });
        const finalData = [...headings, ...spanTexts];
        setSectionContent((prevContent) => ({
          ...prevContent,
          headings: finalData,
        }));
      } else {
        setSectionContent((prevContent) => ({
          ...prevContent,
          headings: headings,
        }));
      }
    }

    if (Array.isArray(textSections) && textSections.length > 0) {
      const descriptions = textSections.map((section) => {
        return {
          id: section.id,
          content: section.content,
          contentType: section.contentType,
          translation: section?.translation,
        };
      });
      console.log("descriptions------->", descriptions);
      setSectionContent((prevContent) => ({
        ...prevContent,
        descriptions: descriptions,
      }));
    }

    if (Array.isArray(imageSections) && imageSections.length > 0) {
      const images = imageSections.map((section) => {
        return {
          id: section.id,
          content: section.content,
          contentType: section.contentType,
          translation: section?.translation,
        };
      });
      setSectionContent((prevContent) => ({
        ...prevContent,
        images: images,
      }));
    }

    if (Array.isArray(navbarSections) && navbarSections.length > 0) {
      const navSections = navbarSections.map((section) => {
        return {
          id: section.id,
          content: JSON.parse(section.content),
          contentType: section.contentType,
          translation: section?.translation,
        };
      });
      console.log("navbar sections from API--------->", navSections);
      setSectionContent((prevContent) => ({
        ...prevContent,
        navbar: navSections,
      }));
    }
    

  }
  const requiredHtml =
  currentLanguage === "en"
    ? response?.data?.secctionHTML?.English
    : response?.data?.secctionHTML?.Arabic;
    console.log('required html res---------->', response.data);
setSectionHtml(requiredHtml);
setSectionTheme(response.data.userTheme);



    // if (heading.content && textSection.content) {
    //   setSectionContent({
    //     heading: heading.content,
    //     text: textSection.content,
    //     image: imageSection.content,
    //   });

    // }
  }, [userId, userSectionId, currentLanguage]);

  useEffect(() => {
    fetchContentBySectionId();
  }, [fetchContentBySectionId]);

  const location = useLocation();

  useEffect(() => {
    // Reset states when URL changes
    setEditable(false);
    setIsLoading(true);
    setSectionContent({
      headings: [],
      descriptions: [],
      images: [],
      navbar: [],
    });
    setSocialMediaData([]);

    console.log("Content state cleared due to URL change");
  }, [location.pathname]);

  const getUpdatedArray = (array, object) => {
    const updatedArray = array.map((item) =>
      item.id === object.id ? object : item
    );
    return updatedArray; // Make sure to return the updated array
  };

  useEffect(()=>{
    console.log('editable', editable)
  },[editable])

  return (
    <div>
      {isLoading && <BackdropLoader />}
      {editable ? (
        <>
          <EditableComponent
            close={() => setEditable(false)}
            onUpdateContent={saveContent}
            sectionContent={content}
            setHeading={(newHeadingObject) => {
              const updatedArray = getUpdatedArray(
                content.headings,
                newHeadingObject
              );
              setSectionContent({ ...content, headings: updatedArray });
            }}
            setDescription={(newDescriptionObject) => {
              const updatedArray = getUpdatedArray(
                content.descriptions,
                newDescriptionObject
              );
              setSectionContent({ ...content, descriptions: updatedArray });
            }}
            setImage={(newImageObject) => {
              const updatedArray = getUpdatedArray(
                content.images,
                newImageObject
              );
              setSectionContent({ ...content, images: updatedArray });
            }}
            navbar={content.navbar}
            setNavBar={(navbarSection) => {
              const updatedArray = getUpdatedArray(
                content.navbar,
                navbarSection
              );
              console.log("updated array---------->", updatedArray);
              setSectionContent({ ...content, navbar: updatedArray });
            }}
          />
          {socialMediaData && (
            <EditableSocialSection
              // close={() => setEditable(false)}
              // onUpdateContent={saveContent}
              // apiSocialLinks={apiSocialLinks}
              socialMediaData={socialMediaData} //social media data
              onSetApiSocialLinks={(apiSocialLinks) => {
                console.log(
                  "api social links inside parent------------->",
                  apiSocialLinks
                );
                // setApiSocialLinks(apiSocialLinks);
              }}
              onSetSocialMediaLink={(socialLinks) => {
                console.log(
                  "updated social links inside parent---------->",
                  socialLinks
                );
                setSocialMediaData(socialLinks);
              }}
            />
          )}
        </>
      ) : (
        <Box>
          {!previewMode && (
            <Button
              className="ml-10 mt-10 -mb-5"
              value="Edit"
              onClick={() => setEditable(true)}
            />
          )}
          <PreviewComponent sectionHtml={sectionHtml} theme={sectionTheme} />
        </Box>
      )}
    </div>
  );
};

export default SectionPreviewPage;